// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { msalInstance } from "./msalInstance";
// import { useDispatch } from "react-redux";
// import { ssoLogin } from "../../Store/authSlice";
// import Swal from "sweetalert2";

// const AuthCallback = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();

//   useEffect(() => {
//     const handleAuth = async () => {
//       // SHOW PROFESSIONAL LOADER
//       Swal.fire({
//         title: "Signing you in...",
//         text: "Please wait while we securely authenticate your account.",
//         allowOutsideClick: false,
//         allowEscapeKey: false,
//         showConfirmButton: false,

//         didOpen: () => {
//           Swal.showLoading();
//         },
//       });

//       try {
//         const response = await msalInstance.handleRedirectPromise();

//         console.log("MSAL Response:", response);

//         if (!response || !response.account) {
//           throw new Error("No response from MSAL");
//         }

//         const account = response.account;

//         msalInstance.setActiveAccount(account);

//         const idToken = response.idToken;

//         // console.log("ID Token:", idToken);

//         const result = await dispatch(ssoLogin(idToken));
//         // console.log("reasult", result);
//         // console.log("reasult", result.payload);

//         if (result.meta.requestStatus === "fulfilled") {
//           localStorage.setItem("isAuthenticated", "true");
//           localStorage.setItem("authtoken", result.payload.token);
//           sessionStorage.setItem("token", result.payload.token);
//           console.log("gettoken", localStorage.getItem("authtoken"));
//           navigate("/");

//           await Swal.fire({
//             icon: "success",
//             title: "Login Successful",
//             text: "Redirecting to dashboard...",
//             timer: 1200,
//             showConfirmButton: false,
//           });

//           // allow redux/auth state to settle
//           await new Promise((resolve) => setTimeout(resolve, 600));

//           navigate("/");
//         } else {
//           throw new Error("Backend login failed");
//         }
//       } catch (error) {
//         console.error("Auth error:", error);

//         // ERROR ALERT
//         await Swal.fire({
//           icon: "error",
//           title: "Authentication Failed",
//           text: "Unable to login. Please try again.",
//           confirmButtonColor: "#3085d6",
//         });

//         navigate("/login");
//       }
//     };

//     handleAuth();
//   }, [dispatch, navigate]);

//   return null;
// };

// export default AuthCallback;

//....18.06.2026...//

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { msalInstance } from "./msalInstance";
import { useDispatch } from "react-redux";
import { ssoLogin } from "../../Store/authSlice";
import Swal from "sweetalert2";

const AuthCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleAuth = async () => {
      //show alert popup
      Swal.fire({
        title: "Signing you in...",
        text: "Please wait while we securely authenticate your account.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      try {
        const response = await msalInstance.handleRedirectPromise();

        if (!response?.account) {
          throw new Error("Microsoft authentication failed");
        }

        msalInstance.setActiveAccount(response.account);

        const idToken = response.idToken;
        //dispatchin token in slice
        const result = await dispatch(ssoLogin(idToken));

        // console.log("SSO Result:", result);

        if (result.meta.requestStatus !== "fulfilled") {
          throw new Error("Backend SSO login failed");
        }
        //result
        const token = result?.payload?.token;

        if (!token) {
          throw new Error("Application token not received");
        }

        // Save token
        sessionStorage.setItem("token", token);

        // Save auth flag
        localStorage.setItem("isAuthenticated", "true");

        await Swal.fire({
          icon: "success",
          title: "Login Successful",
          text: "Redirecting to dashboard...",
          timer: 1200,
          showConfirmButton: false,
        });
        //inside deshboard
        navigate("/", { replace: true });
      } catch (error) {
        console.error("SSO Error:", error);
        //if authentication fail clear token
        sessionStorage.clear();
        localStorage.removeItem("isAuthenticated");

        await Swal.fire({
          icon: "error",
          title: "Authentication Failed",
          text: error.message || "Unable to login",
        });

        navigate("/login", { replace: true });
      }
    };

    handleAuth();
  }, [dispatch, navigate]);

  return null;
};

export default AuthCallback;
